export default {
  titles: {
    locale: 'Choose language', // Kielivalikon otsikko ruudunlukijoita varten
    search: 'Define search terms', // Hakulomakkeen otsikko ruudunlukijoita varten
    candidates: 'Candidates', // Ehdokaslistauksen otsikko ruudunlukijoita varten
    candidateInSocialMedia: 'Candidate in social media', // Ehdokkaan somelinkkien otsikko ruudunlukijoita varten
    donationSum: 'Sum of your donation',
    companyDetails: 'Information of the company / organization',
    donorDetails: 'Information of the donor',
    thanksForYourDonation: 'Thank you for your donation!',
  },
  infoTexts: {
    selectElection: 'Begin by choosing the election.',
    selectConstituency: 'Begin by choosing the electoral district.',
    selectCommune: 'Begin by choosing the municipality.',
    selectWelfareArea: 'Begin by choosing the county.',
    loadingCandidates: 'Loading candidates.',
    noCandidatesFound: 'Your search didn\'t match any candidates.',
    candidatesFound: 'Your search matched one candidate. | Your search matched {count} candidates.',
    defineSearchTerms: 'Define search terms for candidates',
    defineEmbedConfig: 'Define embed options below',
    pasteEmbedCode: 'Copy and paste embed code to your website',
    checkingPayment: 'Checking payment',
    paymentCheckFailed: 'Payment check failed',
  },
  candidate: {
    number: 'Candidate number',
    age: 'Age',
    years: 'years old',
    yearsAbbreviation: 'yo',
    independentAbbreviation: 'ind.',
    donationNotify: 'Donate',
    commune: 'Municipality',
    website: 'Website',
    title: 'Profession',
  },
  buttons: {
    back: {
      label: 'Back',
    },
    closeWindow: {
      label: 'Close window',
    },
    showMore: {
      label: 'Show more',
    },
    showLess: {
      label: 'Show less',
    },
    tryAgain: {
      label: 'Try again',
    },
    embed: {
      label: 'Embed this candidate list to your website',
    },
    donate: {
      label: 'Donate',
    },
    share: {
      label: 'Share',
    },
    copyLink: {
      card: {
        label: 'Copy candidate card link',
      },
      donation: {
        label: 'Copy donation form link',
      },
      success: 'Link copied to clipboard.',
      error: 'Link copy failed. You can copy the link directly here.',
    },
    shareInFacebook: {
      label: 'Share in Facebook',
    },
    shareInTwitter: {
      label: 'Share in X',
    },
    proceedToPayment: {
      label: 'Proceed to payment',
      notes: 'Fundraising license:',
    },
    proceedToPaymentService: {
      label: 'Proceed to payment service',
      notes: 'You will be automatically redirected to the payment service. Please click above if you are not automatically redirected.',
    },
  },
  fields: {
    election: {
      label: 'Election',
    },
    commune: {
      label: 'Municipality',
    },
    constituency: {
      label: 'Electoral district',
    },
    welfareArea: {
      label: 'County',
    },
    gender: {
      label: 'Gender',
    },
    age: {
      label: 'Age',
    },
    sum: {
      label: 'Sum of your donation',
      notes: 'A service fee depending on the payment method will be deducted from the donation.',
    },
    sumCustom: {
      label: 'Other sum',
      notes: 'Sum must be at least 5 €.',
    },
    behalfCompany: {
      label: 'I am donating on the behalf of an company/organization',
    },
    organizationName: {
      label: 'Organization name',
    },
    vatId: {
      label: 'VAT ID',
    },
    organizationType: {
      label: 'Organization type',
    },
    email: {
      label: 'E-mail address',
    },
    firstName: {
      label: 'First name',
    },
    lastName: {
      label: 'Last name',
    },
    donationAbroad: {
      label: 'I don\'t live in Finland',
    },
    postal: {
      label: 'Postal code',
    },
    country: {
      label: 'Country',
    },
    locality: {
      label: 'Locality',
    },
    message: {
      label: 'Your message for the grantee',
    },
    donorContact: {
      label: 'I can be contacted in the future',
      notes: 'I consent to the usage of my information according to the privacy policy',
    },
    donorPublic: {
      label: 'The donor can be published',
      notes: 'Select here whether the information about your donation is public. If you prohibit the publication of your donation, the information of the donation will remain with the party and the target of your donation, and it will not be published anywhere. Optional disclosure only applies to donations that are less than 800. If you donate a total of more than 1500 euros through the service, the donor must be disclosed according to the Act on Political Parties.',
    },
    donorTermsAccepted: {
      label: 'I have read the privacy and data protection policy of the donor register',
    },
    // Upotuskoodin luonti
    showLocale: {
      label: 'Show language menu',
    },
    showSearch: {
      label: 'Show search form',
    },
    showCommune: {
      label: 'Show municipality selection',
    },
    showConstituency: {
      label: 'Show electoral district selection',
    },
    showWelfareArea: {
      label: 'Show county selection',
    },
    showGender: {
      label: 'Show gender selection',
    },
    showAge: {
      label: 'Show age selection',
    },
    showSummary: {
      label: 'Show search results summary text',
    },
    autoPager: {
      label: 'Automatic pagination',
    },
    candidate_type: {
      label: 'Candidate type',
    },
    all: {
      label: 'All',
    },
    green_women: {
      label: 'Green women',
    },
    green_youth: {
      label: 'Green youth',
    },
    green_viite: {
      label: 'Viite',
    },
    embedCode: {
      label: 'Embed code',
    },
  },
}
